import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bg-surface-light py-1" }
const _hoisted_2 = {
  colspan: "100",
  class: "px-4 py-2"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_TableHeader = _resolveComponent("TableHeader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_data_table, {
                "sort-by": _ctx.sortBy,
                "onUpdate:sortBy": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sortBy) = $event)),
                expanded: _ctx.expanded,
                "onUpdate:expanded": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.expanded) = $event)),
                headers: _ctx.headers,
                items: _ctx.benutzerAsList,
                loading: _ctx.loading,
                "custom-sort": _ctx.customSort,
                "must-sort": true,
                "item-value": "objectBenutzerId",
                "show-expand": "",
                "single-expand": "",
                "hide-default-footer": "",
                class: "elevation-1 nowhow-table",
                "items-per-page": -1,
                "onClick:row": _ctx.expandRow
              }, {
                top: _withCtx(() => [
                  _createVNode(_component_TableHeader, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_container, { fluid: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "5"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_text_field, {
                                    modelValue: _ctx.filterData.userSignInEmail,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterData.userSignInEmail) = $event)),
                                    "prepend-inner-icon": "mdi-magnify",
                                    "append-icon": "mdi-close",
                                    label: _ctx.$t('suche'),
                                    "hide-details": "",
                                    autofocus: "",
                                    onKeyup: _withKeys(_ctx.searchEnter, ["enter"]),
                                    "onClick:append": _ctx.clearSearch
                                  }, null, 8, ["modelValue", "label", "onKeyup", "onClick:append"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_v_col, {
                                cols: "12",
                                md: "3"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    class: "mt-2",
                                    color: "primary",
                                    variant: "flat",
                                    onClick: _ctx.searchEnter
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.$t('benutzerSuche.search')), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                "item.kundenNummer": _withCtx(({ item }) => [
                  (item.lieferantenNummer)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(item.lieferantenNummer), 1)
                      ], 64))
                    : (item.kundenNummer)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(item.kundenNummer), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                ]),
                "item.firma": _withCtx(({ item }) => [
                  _createTextVNode(_toDisplayString(item.firma), 1)
                ]),
                "item.plz": _withCtx(({ item }) => [
                  (item.plz !== 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(item.plz), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                "item.ort": _withCtx(({ item }) => [
                  _createTextVNode(_toDisplayString(item.ort), 1)
                ]),
                "item.userSignInEmail": _withCtx(({ item }) => [
                  _createTextVNode(_toDisplayString(item.userSignInEmail), 1)
                ]),
                "item.burgermenu": _withCtx(({ item }) => [
                  _createVNode(_component_v_btn, {
                    icon: "",
                    href: item.burgermenu,
                    flat: "",
                    alt: "test",
                    onClick: ($event: any) => (_ctx.initTakeSpecific(item.teilnehmerId, item.objectBenutzerId))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, {
                        color: "primary",
                        icon: "mdi-account-cog"
                      })
                    ]),
                    _: 2
                  }, 1032, ["href", "onClick"])
                ]),
                "item.data-table-expand": _withCtx(({ item }) => [
                  _createVNode(_component_v_btn, {
                    icon: "",
                    class: "elevation-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.isRowExpanded(item) ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                "expanded-row": _withCtx(({}) => [
                  _createElementVNode("tr", _hoisted_1, [
                    _cache[3] || (_cache[3] = _createElementVNode("td", { class: "d-none d-md-table-cell" }, null, -1)),
                    _createElementVNode("td", _hoisted_2, [
                      _createVNode(_component_v_row, { class: "d-flex flex-wrap" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6",
                            class: "mb-2"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('einstellungen.benutzer.rollen') + ' '), 1),
                              (_ctx.benutzerDetails && _ctx.benutzerDetails.rollen)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('benutzerrollen.' + _ctx.benutzerDetails.rollen.toString().toLowerCase())), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_4, "-"))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "6",
                            class: "mb-2"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t('einstellungen.benutzer.mobile') + ' '), 1),
                              (_ctx.benutzerDetails && _ctx.benutzerDetails.mobilNummer)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.benutzerDetails.mobilNummer), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_6, "-"))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["sort-by", "expanded", "headers", "items", "loading", "custom-sort", "onClick:row"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}